<template>
<div>
  <Navigation />
  <b-container class="text-left" style="margin-top: 100px;">
    <!-- Version 2.0 -->
    <b-row cols="12" class="mb-5">
      <b-col cols="12">
        <h2>v2.0</h2>
      </b-col>
      <b-col cols="12">
        <h4>Improvements</h4>
      </b-col>
      <b-col cols="11" offset="1">
        <NoteItem title="Updated sound indicator icon" image="sound_icon.png" />
      </b-col>
      <b-col cols="11" offset="1" class="mt-3">
        <NoteItem title="Fixed bug where selecting 'Close selected tabs' options in new Session page wouldn't close tabs" />
      </b-col>
      <b-col cols="12" class="mt-5">
        <h4>New Features</h4>
      </b-col>
      <b-col cols="11" offset="1">
        <NoteItem title="Support for Dark Theme" image="darktheme.png" />
      </b-col>
      <b-col cols="11" offset="1" class="mt-3">
        <NoteItem title="New Windows View to manage tabs" image="windowsview.png" />
      </b-col>
    </b-row>

    <!-- Version 1.2.0 -->
    <b-row cols="12">
      <b-col cols="12">
        <h2>v1.2.0</h2>
      </b-col>
      <b-col cols="12">
        <h4>Improvements</h4>
      </b-col>
      <b-col cols="11" offset="1">
        <NoteItem title="Local files have their own category now" image="local_files_category.png" />
      </b-col>
      <b-col cols="11" offset="1" class="mt-4">
        <NoteItem title="Added extra actions to category" image="category_menu.png" />
      </b-col>
      <b-col cols="12" class="mt-5">
        <h4>New Features</h4>
      </b-col>
      <b-col cols="11" offset="1">
        <NoteItem title="Shows notifications when new features are available" image="feature_notification.png" />
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import Navigation from '@/shared/Navigation';
import NoteItem from '@/components/NoteItem';

export default {
  name: 'ReleaseNotesPage',
  components: { Navigation, NoteItem },
  data() {
    return{
      
    }
  }
}
</script>

<style scoped>

</style>
